import React, { Component } from "react";
import PropTypes from "prop-types";
import { Icon, Button } from "antd";
import Link from "../page-link";
import Logo from "../logo";
import HeaderUser from "../header-user";
import HeaderMenu from "../header-menu";
import HeaderFullScreen from "../header-full-screen";
import LanguageSelect from "../header-language-select";
import ThemeColorPicker from "../header-color-picker";
import HeaderNotices from "../header-notice";
import { connect } from "../../models/index";
import { PAGE_FRAME_LAYOUT } from "@/models/settings";
import Breadcrumb from "../breadcrumb";
import "./style.less";
import { L } from "@/lib/abpUtility";
import { isGranted } from "@/lib/abpUtility";
import { toAdmin } from "@/commons";
import { FormattedMessage } from "react-intl";
import { getDocumentUrl } from '@/pages/V2/apis/common';

declare var abp: any;
var logosrc='';
@connect((state) => {
    const { menus, topMenu } = state.menu;
    const {
        show: showSide,
        width,
        collapsed,
        collapsedWidth,
        dragging,
    } = state.side;
    const { breadcrumbs } = state.page;
    const { pageFrameLayout } = state.settings;
    const { unreadCount } = state.notification;

    return {
        menus,
        topMenu,

        showSide,
        sideWidth: width,
        sideCollapsed: collapsed,
        sideCollapsedWidth: collapsedWidth,
        sideDragging: dragging,
        breadcrumbs,
        unreadCount,
        layout: pageFrameLayout,
    };
})

export default class Header extends Component {
    static propTypes = {
        layout: PropTypes.string,
        theme: PropTypes.string,
    };

    static defaultProps = {
        layout: PAGE_FRAME_LAYOUT.SIDE_MENU, // top-side-menu top-menu side-menu
        theme: "default", // default dark
    };
    componentDidMount() {
        this.props.action.notification.getNotificationList({
            state: 0,
            MaxResultCount: 10,
            SkipCount: 0,
        });
    }

    handleToggle = () => {
        const { sideCollapsed } = this.props;
        this.props.action.side.setCollapsed(!sideCollapsed);
    };

    handleOpenAppManager = () => {
        toAdmin();
    };

    render() {
        let {
            layout,
            menus, // 所有的菜单数据
            topMenu, // 当前页面选中菜单的顶级菜单
            sideCollapsed,
            sideCollapsedWidth,
            sideWidth,
            sideDragging,
            breadcrumbs,
            children,
            unreadCount,
        } = this.props;
        sideWidth = sideCollapsed ? sideCollapsedWidth : sideWidth;

        const isTopSideMenu = layout === PAGE_FRAME_LAYOUT.TOP_SIDE_MENU;
        const isTopMenu = layout === PAGE_FRAME_LAYOUT.TOP_MENU;
        const isSideMenu = layout === PAGE_FRAME_LAYOUT.SIDE_MENU;
        const showToggle = isTopSideMenu || isSideMenu;
        const showMenu = isTopSideMenu || isTopMenu;

        const logoid = JSON.parse(abp.setting.values['CustomizeLoginPage']).LogoId;
        var logosrc = 'data:image/jpg;base64,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';
        if(logosrc==''){
            getDocumentUrl(logoid).then((data) => {
                if (data) {
                    logosrc = data.result.base64s[0]??data.result.url;
                }
            });
        }
        const arrMenus = menus.filter(item => item?.type === 'App')
        let topMenus = arrMenus;
        if (isTopSideMenu) {
            topMenus =
                arrMenus &&
                arrMenus.map((item) => ({
                    key: item.key,
                    text: item.text,
                    path: item.path,
                    icon: item.icon,
                }));
        }
        if (isTopMenu) {
            topMenus = arrMenus;
        }

        let transitionDuration = sideDragging ? "0ms" : "300ms";

        const theme = this.props.theme || ((isTopSideMenu || isSideMenu) ? 'default' : 'dark');
        var goBackManager=false;
        if(isGranted("App.Permissions.Admin.Login"))
            {
                goBackManager=true;
            }
            const { CustomizeLoginPage } = abp.setting.values;
            const setting = JSON.parse(CustomizeLoginPage);
            // const logo = abp.setting.values['App.Api.Default.Host'] + '/enterprise/'+setting?.Logo;
            const logo = abp.setting.values['App.General.HomeUrl'];
        return (
            <div id="header" styleName="header" data-theme={theme}>
                <div styleName="logo-container" id="logo-container" style={{flex: `0 0 ${sideWidth}px`, transitionDuration}}>
                    {/* <Link to={logo}> */}
                    <div>
                        <Logo
                            min={sideCollapsed}
                            title={setting.SystemName}
                            // src={logosrc}
                            src={logo}
                        />
                    </div>
                </div>
                {/* {showToggle ? (
                    <Icon
                        className="header-trigger"
                        styleName="trigger"
                        type={sideCollapsed ? "menu" : "menu"}
                        onClick={this.handleToggle}
                        style={
                            theme === "dark"
                                ? { color: "#fff", backgroundColor: "#222" }
                                : null
                        }
                    />
                ) : null} */}
                {children ? (
                    <div styleName="center">{children}</div>
                ) : (
                    <div styleName="center">
                        {showMenu ? (
                            <HeaderMenu
                                theme={theme}
                                dataSource={topMenus}
                                selectedKeys={[topMenu && topMenu.key]}
                            />
                        ) : null}
                        {isSideMenu ? (
                            <div style={{ marginLeft: 16 }}>
                                <Breadcrumb
                                    theme={theme}
                                    dataSource={breadcrumbs}
                                />
                            </div>
                        ) : null}
                    </div>
                )}

                <div styleName="right">
                    {goBackManager ? (
                        <div
                            styleName="button"
                            className="header-button"
                            onClick={this.handleOpenAppManager}
                            style={{fontSize:'16px'}}
                        >
                            <FormattedMessage id="enterBackManagement" />
                        </div>
                    ) : null}
                    <LanguageSelect
                        styleName="action"
                        className="header-action"
                    ></LanguageSelect>
                    <HeaderNotices
                        styleName="action"
                        tips={unreadCount}
                        className="header-action"
                    ></HeaderNotices>
                    <ThemeColorPicker
                        styleName="action"
                        className="header-action"
                    />
                    <HeaderUser
                        styleName="action"
                        className="header-action"
                        theme={theme}
                    />
                    <HeaderFullScreen
                        styleName="screen"
                        className="header-screen"
                    />
                </div>
            </div>
        );
    }
}
